import React from 'react';
import { useParams } from 'react-router-dom';
import BankStatementReport from './BankStatementReport.component';
import OtherIncomeReport from './OtherIncomeReport.component';
import NozzleReport from './NozzleReport.component';
import GenericOtherReport from './GenericOtherReport.component';
import { otherReportBySlug } from '../../constant/otherReportsConfig';

/**
 * Routes /other-reports/:slug to the dedicated or generic React report screen.
 */
const OtherReportRouter = (props) => {
  const { slug } = useParams();
  const report = otherReportBySlug(slug);

  if (!report) {
    return <GenericOtherReport {...props} />;
  }

  if (slug === 'bank_statement') {
    return <BankStatementReport {...props} otherReportSlug={slug} />;
  }

  if (slug === 'other_income_statement') {
    return <OtherIncomeReport {...props} otherReportSlug={slug} />;
  }

  if (slug === 'nozzle_report') {
    return <NozzleReport {...props} otherReportSlug={slug} />;
  }

  return <GenericOtherReport {...props} />;
};

export default OtherReportRouter;
